// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatbotOverlay_root__0QobD"};